import { ChartType } from "../../Component/Model/Enum/ChartType";


const doubleColumnChartSuffix: string = ' (Bar Chart)';
const pieChartSuffix: string = ' (Pie Chart)';
const tableSuffix: string = ' (Table)';

export const getChartSuffix = (chartType: ChartType): string => {
    const chartTypeString = ChartType[chartType].toString().toLowerCase();
    if (chartTypeString.includes('columnchart')) return doubleColumnChartSuffix;
    if (chartTypeString.includes('piechart')) return pieChartSuffix;
    if (chartTypeString.includes('table')) return tableSuffix;

    return '';
}